import { Box, Link, Typography } from "@mui/material";

type IProps = {
  title: string;
  description?: string;
  my?: number;
  isLink?: boolean;
  sameTab?: boolean;
  isTel?: boolean;
  linkTitle?: string;
  isSectionTitle?: boolean;
};

const Info: React.FC<IProps> = ({
  title,
  description,
  my = 1.5,
  isLink = false,
  sameTab = false,
  isTel = false,
  linkTitle = "",
  isSectionTitle = false,
}) => {
  return (
    <Box sx={{ display: "flex", my }}>
      {isSectionTitle ? (
        <Typography
          variant="body1"
          component="p"
          color="primary"
          sx={{ fontWeight: "700", mr: 1, mt: 1, fontSize: 24, textWrap: "nowrap" }}
        >
          {title}
        </Typography>
      ) : (
        <Typography
          variant="body1"
          component="p"
          color="primary"
          sx={{ fontWeight: "700", mr: 1, fontSize: 18, textWrap: "nowrap" }}
        >
          {title}:
        </Typography>
      )}
      {description &&
        (isLink ? (
          <Link
            sx={{ fontSize: 18, lineBreak: "anywhere" }}
            href={isTel ? `tel:${description}` : description}
            title={linkTitle}
            target={sameTab ? "_self" : "_blank"}
          >
            {description}
          </Link>
        ) : (
          <Typography
            variant="body1"
            component="p"
            sx={{ fontSize: 18, whiteSpace: "pre-wrap" }}
          >
            {description}
          </Typography>
        ))}
    </Box>
  );
};

export default Info;
